import { forwardRef } from 'react';
import { Source } from '@kit/source';
import { Track } from '@kit/track';
import { TRACK_KIND } from '@kit/track/types';
import { VideoProps, VideoRefElement } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const _Video: React.ForwardRefRenderFunction<VideoRefElement, VideoProps> = (props, ref) => {
  const {
    children,
    src,
    type,
    label,
    srcLang,
    ...restProps
  } = props;
  return _jsxs("video", {
    //
    ref: ref,
    autoPlay: true,
    muted: true,
    playsInline: true,
    ...restProps,
    children: [children, _jsx(Source //
    , {
      src: src,
      type: type
    }), _jsx(Track //
    , {
      kind: TRACK_KIND.CAPTIONS,
      label: label,
      srcLang: srcLang,
      default: true
    })]
  });
};
export const Video = /*#__PURE__*/forwardRef(_Video);